/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Tc_From_GroupInputs */



/**
* | output |
* | --- |
* | "Copy TC From Group" |
*
* @param {Copy_Tc_From_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_tc_from_group = /** @type {((inputs?: Copy_Tc_From_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Tc_From_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le CT du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC aus Gruppe kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia TC dal gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать TC из группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar TC del grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从组复制 TC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループからTCをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह से टीसी कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar TC do grupo")
	return /** @type {LocalizedString} */ ("Copy TC From Group")
});